import styled, { css } from 'styled-components';
import { hexToRgba } from '../../../features/Theme/domain';

export const InfoBoxTitle = styled.div`
	${({ theme }) => css`
		text-align: left;
		font-size: ${theme.fontSizes.default};
		font-weight: ${theme.fontWeights.regular};
		color: ${theme.colors.brand.primary[300]};
	`}
`;

export const InfoBoxContent = styled.div`
	${({ theme }) => css`
		display: grid;
		place-content: center;
		height: 63px;
		width: 100%;
		padding: 10px;
		border-radius: ${theme.radii.default};
		text-align: center;
		font-size: ${theme.fontSizes.l};
		font-weight: ${theme.fontWeights.bold};
		border: none;
		color: ${theme.colors.brand.primary[300]};
		background-color: ${hexToRgba(theme.colors.brand.accent[300], 0.1)};
	`}
`;
